import { Component, input, output } from '@angular/core'
import { takeUntilDestroyed, toObservable } from '@angular/core/rxjs-interop'
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms'
import { CommonModule } from '@angular/common'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatSelectModule } from '@angular/material/select'
import { CurrencyCode, ICurrency } from 'src/app/core/interfaces/currency.interface'

@Component({
  selector: 'app-currency',
  template: `
    <mat-form-field
      class="Currency select select-medium select-outlined hide-subscript theme-form-field theme-select"
      [class.Currency--single]="options().length === 1"
      i18n-aria-label="@@currency.aria-label"
      aria-label="Select your currency preference"
      appearance="outline"
    >
      <mat-select
        panelClass="Currency__panel"
        [formControl]="formControl"
        (selectionChange)="selectCurrency.emit($event.value)"
        disableRipple
        data-testid="currency-select"
      >
        @for (currency of options(); track currency) {
          <mat-option
            class="Currency__option"
            [value]="currency.code"
            data-testid="currency-option"
          >
            {{currency.symbol}} {{currency.code}}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  `,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatSelectModule,
  ],
})

export class CurrencyComponent {
  options = input.required<ICurrency[]>()
  selectedOption = input.required<ICurrency>()
  selectCurrency = output<CurrencyCode>()

  formControl = new FormControl()

  constructor() {
    toObservable(this.options).pipe(
      takeUntilDestroyed(),
    ).subscribe(() => {
      if (this.formControl.value && !this.options()?.find(option => option.code === this.formControl.value)) {
        this.formControl.setValue(this.options()[0].code)
        this.selectCurrency.emit(this.options()[0].code)
      }
      if (this.options().length === 1) {
        this.formControl.disable()
      }
    })
    toObservable(this.selectedOption).pipe(
      takeUntilDestroyed(),
    ).subscribe(() => {
      this.formControl.setValue(this.selectedOption()?.code)
    })
  }
}
